

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onVariantChange = this.onVariantChange.bind(this);
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput();

    // FILTRADO ESTRICTO: la primera opción (índice 0) es la principal
    this.filterByPrimary();
this.updateQtyMax();      // ← aquí
    // Cantidad / botón según variante inicial
    this.updateQtyMax();
    if (this.currentVariant && this.currentVariant.available) {
      this.toggleAddButton(false, '', false);
    } else {
      this.toggleAddButton(true, '', true);
    }
  }

  onVariantChange(evt) {
    this.updateOptions();
    this.updateMasterId();

    // Cada vez que cambia algo, re-filtra según la primera opción
    this.filterByPrimary();

    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateQtyMax();
      this.renderProductInfo();
    }
  }

  // ================== utilidades de selección ==================
  updateOptions() {
    // dropdowns (id="Option-<section>-<idx>")
    const optionSelects = Array.from(this.querySelectorAll('select[id^="Option-"]'));
    if (optionSelects.length) {
      this.options = optionSelects.map(s => s.value);
      return;
    }
    // swatches (fieldset[data-option-index])
    const fieldsets = Array.from(this.querySelectorAll('fieldset[data-option-index]'));
    if (fieldsets.length) {
      this.options = fieldsets.map(fs => {
        const r = fs.querySelector('input[type="radio"]:checked');
        return r ? r.value : null;
      });
      return;
    }
    this.options = [];
  }

  updateMasterId() {
    const data = this.getVariantData();
    this.currentVariant = data.find(variant => {
      return !variant.options.map((opt, i) => this.options[i] === opt).includes(false);
    }) || null;
  }

  // ================== core de filtrado simple (2 opciones) ==================
  isSellable(variant) {
    const managed = !!variant.inventory_management;
    const deny = String(variant.inventory_policy || '').toLowerCase() === 'deny';
    const qty = Number(variant.inventory_quantity);
    return managed && deny ? (Number.isFinite(qty) && qty > 0) : !!variant.available;
  }

  // 1ª opción es la principal:
  // - Muestra SOLO valores de la 1ª con alguna combinación vendible.
  // - Con la 1ª elegida, muestra SOLO valores de la 2ª que tengan stock con esa 1ª.
  filterByPrimary() {
    const variants = this.getVariantData();
    if (!variants?.length) return;

    const optionCount = variants[0].options.length;
    if (optionCount === 0) return;

    // helpers para apuntar a los selectores de opciones (sin tocar #productSelect)
    const selByIdx = (idx) => this.querySelector(`select#Option-${this.dataset.section}-${idx}`);
    const fsByIdx  = (idx) => this.querySelector(`fieldset[data-option-index="${idx}"]`);

    // --- calcular permitidos de la PRIMERA opción (índice 0)
    const allowedPrimary = new Set(
      variants.filter(v => this.isSellable(v)).map(v => v.options[0])
    );

    // aplicar en UI de la PRIMERA opción
    const fs0 = fsByIdx(0);
    const s0  = selByIdx(0);
    let selectedPrimary = null;

    if (fs0) {
      const radios = Array.from(fs0.querySelectorAll('input[type="radio"]'));
      let hasCheckedVisible = false;
      radios.forEach(input => {
        const show = allowedPrimary.has(input.value);
        const wrap = input.closest('div') || input.parentElement;
        if (wrap) wrap.style.display = show ? '' : 'none';
        input.disabled = !show;
        if (show && input.checked) {
          hasCheckedVisible = true;
          selectedPrimary = input.value;
        }
        if (!show && input.checked) input.checked = false;
      });
      if (!hasCheckedVisible) {
        const firstVisible = radios.find(i => !i.disabled && ((i.closest('div') || i.parentElement)?.style.display !== 'none'));
        if (firstVisible) {
          firstVisible.checked = true;
          selectedPrimary = firstVisible.value;
        }
      }
    } else if (s0) {
      let currentValid = false;
      const opts = Array.from(s0.options);
      opts.forEach(o => {
        if (!o.value) return;
        const ok = allowedPrimary.has(o.value);
        o.disabled = !ok;
        o.hidden   = !ok;
        if (ok && o.selected) {
          currentValid = true;
          selectedPrimary = o.value;
        }
      });
      if (!currentValid) {
        const firstOk = opts.find(o => o.value && !o.disabled && !o.hidden);
        if (firstOk) {
          s0.value = firstOk.value;
          selectedPrimary = firstOk.value;
        }
      }
    }

    // si no hay segunda opción, sincroniza y listo
    if (optionCount < 2) {
      this.updateOptions();
      this.updateMasterId();
      this.updateVariantInput();
      return;
    }

    // --- con la primera elegida, calcular permitidos de la SEGUNDA opción (índice 1)
    // si todavía no hay una selección válida en la 1ª, intenta tomar la primera permitida
    if (!selectedPrimary) {
      selectedPrimary = Array.from(allowedPrimary)[0] || null;
    }

    const allowedSecond = new Set(
      variants
        .filter(v => this.isSellable(v) && v.options[0] === selectedPrimary)
        .map(v => v.options[1])
    );

    // aplicar en UI de la SEGUNDA opción
    const fs1 = fsByIdx(1);
    const s1  = selByIdx(1);

    if (fs1) {
      const radios = Array.from(fs1.querySelectorAll('input[type="radio"]'));
      let hasCheckedVisible = false;
      radios.forEach(input => {
        const show = allowedSecond.has(input.value);
        const wrap = input.closest('div') || input.parentElement;
        if (wrap) wrap.style.display = show ? '' : 'none';
        input.disabled = !show;
        if (show && input.checked) hasCheckedVisible = true;
        if (!show && input.checked) input.checked = false;
      });
      if (!hasCheckedVisible) {
        const firstVisible = radios.find(i => !i.disabled && ((i.closest('div') || i.parentElement)?.style.display !== 'none'));
        if (firstVisible) firstVisible.checked = true;
      }
    } else if (s1) {
      let currentValid = false;
      const opts = Array.from(s1.options);
      opts.forEach(o => {
        if (!o.value) return;
        const ok = allowedSecond.has(o.value);
        o.disabled = !ok;
        o.hidden   = !ok;
        if (ok && o.selected) currentValid = true;
      });
      if (!currentValid) {
        const firstOk = opts.find(o => o.value && !o.disabled && !o.hidden);
        if (firstOk) s1.value = firstOk.value;
      }
    }

    // sincroniza selección/variante por si hubo autocambios
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput();
  }

  // ================== media / url / pickup ==================
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    const itemact = document.querySelectorAll('.FeaturedImage_slick .item');
    for (let i = 0; i < itemact.length; i++) itemact[i].classList.remove('act');
    newMedia.classList.add('act');
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant?.id || '';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  // ================== cantidad / botón ==================
 updateQtyMax() {
  const sectionId = this.dataset.section;
  const form = document.getElementById(`product-form-${sectionId}`);
  const qty  = document.getElementById('Quantity');
  const addButton  = form?.querySelector('[name="add"]');
  // Si no existe #AddToCartText, usamos el propio botón como fallback
  const addBtnText = addButton?.querySelector('#AddToCartText') || addButton;
  if (!form || !qty || !this.currentVariant || !addButton || !addBtnText) return;

  // 1) Lee stock desde <option data-qty> de la variante actual (preferido)
  const variantId = this.currentVariant.id;
  const optEl = document.getElementById('productSelect')?.querySelector(`[value="${variantId}"]`);
  let stockFromOption = NaN;
  if (optEl) {
    const s = parseInt(optEl.getAttribute('data-qty'), 10);
    if (!isNaN(s)) stockFromOption = s;
  }

  // 2) Fallback: usa currentVariant.inventory_quantity solo si gestiona stock y es DENY
  let stock = stockFromOption;
  if (isNaN(stock)) {
    const managed = !!this.currentVariant.inventory_management;
    const deny    = String(this.currentVariant.inventory_policy || '').toLowerCase() === 'deny';
    const q       = Number(this.currentVariant.inventory_quantity);
    if (managed && deny && Number.isFinite(q)) stock = q;
  }

  // 3) Aplica max al input
  if (!isNaN(stock)) {
    qty.setAttribute('max', String(Math.max(0, stock)));
  } else {
    // si no tenemos stock legible, no ponemos tope duro
    qty.removeAttribute('max');
  }

  // 4) Mensajes y bloqueo
  const STR     = window.variantStrings || {};
  const TXT_ADD = STR.addToCart || 'Añadir al carrito';
  const TXT_PRE = STR.preorder  || 'Pre-ordenar';
  const TXT_NO  = STR.notEnoughStock || 'No hay stock suficiente';

  const applyQtyState = () => {
    const maxAttr = qty.getAttribute('max');
    const max = maxAttr ? parseInt(maxAttr, 10) : NaN;
    const val = parseInt(qty.value, 10) || 1;

    if (Number.isFinite(max) && val > max) {
      addButton.setAttribute('disabled', 'true');
      addBtnText.textContent = TXT_NO;
    } else {
      addButton.removeAttribute('disabled');
      addBtnText.textContent = (Number.isFinite(max) && max < 1) ? TXT_PRE : TXT_ADD;
    }
  };

  // 5) Enlaza una sola vez
  if (!qty.dataset.qtyStateBound) {
    qty.addEventListener('input', applyQtyState);
    qty.addEventListener('blur', () => {
      const maxAttr = qty.getAttribute('max');
      const max = maxAttr ? parseInt(maxAttr, 10) : NaN;
      let v = parseInt(qty.value, 10) || 1;
      if (Number.isFinite(max) && v > max) v = (max || 1);
      if (v < 1) v = 1;
      qty.value = String(v);
      applyQtyState();
    });

    const plus  = form.querySelector('.quick_view-qty-plus');
    const minus = form.querySelector('.quick_view-qty-minus');
    const rebound = () => setTimeout(applyQtyState, 0);
    plus  && plus.addEventListener('click', rebound);
    minus && minus.addEventListener('click', rebound);

    form.addEventListener('submit', (e) => {
      const maxAttr = qty.getAttribute('max');
      const max = maxAttr ? parseInt(maxAttr, 10) : NaN;
      const v = parseInt(qty.value, 10) || 1;
      if (Number.isFinite(max) && v > max) {
        e.preventDefault();
        applyQtyState(); // deja el aviso en el botón
      }
    });

    qty.dataset.qtyStateBound = '1';
  }

  // 6) Evaluación inicial (para la variante por defecto y cada cambio)
  applyQtyState();
}

  renderProductInfo() {
    if (!this.currentVariant) return;
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then(r => r.text())
      .then(responseText => {
        const id = `ProductPrice-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.notify_me);

        const variant_id = document.getElementById('variant_id')?.getAttribute('value');
        const optEl = document.getElementById('productSelect')?.querySelector(`[value="${variant_id}"]`);
        const sku = optEl?.getAttribute('data-sku');
        if (sku && document.getElementById('variantSku')) {
          document.getElementById('variantSku').innerHTML = sku;
        }

        // refuerza tope por si cambia con la respuesta
        const qtyInput = document.getElementById('Quantity');
        if (qtyInput && optEl) {
          const stock = parseInt(optEl.getAttribute('data-qty'), 10);
          if (!isNaN(stock)) {
            qtyInput.setAttribute('max', String(Math.max(0, stock)));
            let val = parseInt(qtyInput.value, 10);
            if (isNaN(val) || val < 1) val = 1;
            if (stock >= 0 && val > stock) val = stock || 1;
            qtyInput.value = String(val);
          }
        }

        this.updateQtyMax();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    const addButton2 = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add2"]');
    const addButton3 = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('.product-form__item--checkout');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      addButton.parentElement.style.display = 'none';
      addButton2 && (addButton2.style.display = 'block');
      addButton3 && addButton3.setAttribute('disabled', true);
      if (text && addButton2) addButton2.querySelector('#txt-notify').textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton2 && (addButton2.style.display = 'none');
      addButton.parentElement.style.display = 'block';
      addButton3 && addButton3.removeAttribute('disabled');

      const variant_id = document.getElementById('variant_id')?.getAttribute('value');
      const optEl = document.getElementById('productSelect')?.querySelector(`[value="${variant_id}"]`);
      const qty_var = optEl ? parseInt(optEl.getAttribute('data-qty'), 10) : NaN;

      if (!isNaN(qty_var) && qty_var < 1) {
        addButton.querySelector('#AddToCartText').textContent = window.variantStrings.preorder;
      } else {
        addButton.querySelector('#AddToCartText').textContent = window.variantStrings.addToCart;
      }

      const qtyInput = document.getElementById('Quantity');
      if (qtyInput && !isNaN(qty_var)) {
        qtyInput.setAttribute('max', String(Math.max(0, qty_var)));
        let v = parseInt(qtyInput.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        const cap = Math.max(0, qty_var);
        if (v > cap) v = cap || 1;
        qtyInput.value = String(v);
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`ProductPrice-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('product-variant-dropdown', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() { super(); }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset[data-option-index]'));
    this.options = fieldsets.map(fs => {
      const r = fs.querySelector('input[type="radio"]:checked');
      return r ? r.value : null;
    });
  }
}
customElements.define('product-variant-swatch', VariantRadios);

// Fallback para productos SIN selector de variantes (Default Title)
document.addEventListener('DOMContentLoaded', () => {
  const hasVariantWidget = document.querySelector('product-variant-swatch, product-variant-dropdown');
  if (hasVariantWidget) return;

  const form = document.querySelector('form.product-form');
  const qty = document.getElementById('Quantity');
  const addButton = form?.querySelector('[name="add"]');
  const addBtnText = addButton?.querySelector('#AddToCartText');
  const selectEl = document.getElementById('productSelect'); // <option data-qty data-sku>
  if (!form || !qty || !addButton || !addBtnText || !selectEl) return;

  const STR = window.variantStrings || {};
  const TXT_ADD = STR.addToCart || 'Añadir al carrito';
  const TXT_PRE = STR.preorder  || 'Pre-ordenar';
  const TXT_NO  = STR.notEnoughStock || 'No hay stock suficiente';

  const getStock = () => {
    const opt = selectEl.querySelector('option[selected], option:checked') ||
                selectEl.options[selectEl.selectedIndex] ||
                selectEl.querySelector('option');
    return opt ? parseInt(opt.getAttribute('data-qty'), 10) : NaN;
  };

  const applyState = () => {
    const stock = getStock();
    if (Number.isFinite(stock)) qty.setAttribute('max', String(Math.max(0, stock)));
    else qty.removeAttribute('max');

    const maxAttr = qty.getAttribute('max');
    const max = maxAttr ? parseInt(maxAttr, 10) : NaN;
    const val = parseInt(qty.value, 10) || 1;

    if (Number.isFinite(max) && val > max) {
      addButton.setAttribute('disabled', 'true');
      addBtnText.textContent = TXT_NO;
    } else {
      addButton.removeAttribute('disabled');
      addBtnText.textContent = (Number.isFinite(max) && max < 1) ? TXT_PRE : TXT_ADD;
    }
  };

  qty.addEventListener('input', applyState);
  qty.addEventListener('blur', () => {
    const maxAttr = qty.getAttribute('max');
    const max = maxAttr ? parseInt(maxAttr, 10) : NaN;
    let v = parseInt(qty.value, 10) || 1;
    if (Number.isFinite(max) && v > max) v = max || 1;
    if (v < 1) v = 1;
    qty.value = String(v);
    applyState();
  });

  const plus  = form.querySelector('.quick_view-qty-plus');
  const minus = form.querySelector('.quick_view-qty-minus');
  const rebound = () => requestAnimationFrame(applyState);
  plus  && plus.addEventListener('click', rebound);
  minus && minus.addEventListener('click', rebound);

  form.addEventListener('submit', (e) => {
    const maxAttr = qty.getAttribute('max');
    const max = maxAttr ? parseInt(maxAttr, 10) : NaN;
    const v = parseInt(qty.value, 10) || 1;
    if (Number.isFinite(max) && v > max) {
      e.preventDefault();
      applyState();
    }
  });

  applyState();
});
